<template>
    <div class="flex-col padding-20 dynamicArea">
        <!--        <base-info-view ref="baseInfo" :pre-data="baseInfoPreData">-->
        <dynamic-view slot="dynamicForm" ref="dynamicData" :dynamic-data="formData"/>
        <!--        </base-info-view>-->
    </div>
</template>

<script>
    import BaseInfoView from "../components/baseInfo";
    import DynamicView from "../components/dynamicFormView";
    import jsonData from './body.json'
   
    // import jsonData from './test3.json'
    // import jsonData from './授权合同.json'
    // import jsonData from './授权合同编辑数据.json'
    // import jsonData from './新授权合同编辑.json'
    export default {
        name: 'HelloWorld', 
        components: {DynamicView, BaseInfoView},
        data() {
            return {
                baseInfoPreData: {},
                // formData: null,
                formData: jsonData,

            }
        },
        props: {
            params: {
                type: Object,
                default() {
                    return {};
                },
            },
            ocrMap: {
                type: Object,
                default() {
                    return {};
                }
            },
            interactionBridge: Function,
            interactionDown: Function,
        },
        watch: {
            params: {
                handler(newValue) {
                    // 外部参数
                    console.log('动态表单组件获取到外部参数为=', newValue);
                    this.analysisData(newValue);
                },
                immediate: true
            },
        },
        mounted() {
            this.$root.$on('jqBridge', this.onBridgeConnect);
            this.$const.ocrMap = this.ocrMap;
            console.log("mounted-this.ocrMap=",this.ocrMap);
            let ocrMapRe = {};
            if (!this.$verify.isEmpty(this.ocrMap)) {
                for (const key in this.ocrMap) {
                    if (this.ocrMap.hasOwnProperty(key)) {
                        ocrMapRe[this.ocrMap[key]] = key;
                    }
                }
            }
            console.log("mounted-ocrMapRe=",ocrMapRe);
            this.$const.ocrMapRe = ocrMapRe;
            // let newData=[
            //     {name: "邓力华", sex: "男", credentialsNo: "511681199505150032"},
            //     {name: "冯标", sex: "男", credentialsNo: "510922199604150674"}
            //     ]
            // localStorage.setItem('restaurants', JSON.stringify(newData))
        },
        destroyed() {
            this.$root.$off('jqBridge', this.onBridgeConnect);
        },
        methods: {
            onBridgeConnect($event) {
                // 收到最上层ocr事件-传递出去
                let {event, data} = $event, param;
                switch (event) {
                    case 'doOcrNow':
                        data.dynamicData = this.formData;
                        param = {event, data}
                        break;
                    case 'doOcrDown':
                        this.interactionDown(data)
                        break;
                    default:
                        param = $event;
                        break
                }
                if (event !== 'doOcrDown') {
                    this.interactionBridge(param);
                }


            },
            //jq 调用判断方法
            respondJq(value) {
                console.log(value, 'jq过来')
                this.$root.$emit('goBack_Vue', {event: 'jqData', data: value})
            },
            analysisData(params) {
                if (this.$verify.isEmpty(params)) return;
                console.log('params=', params);
                let {purpose, territory, trans, notaryInfo, dynamicData} = params;
                this.baseInfoPreData = {purpose, territory, trans, notaryInfo};
                this.formData = dynamicData;
            },

            /**
             * 刷新所有数据
             */
            refreshDynamicData(newData) {
                if (this.$verify.isEmpty(newData)) {
                    this.onBridgeConnect({
                        event: 'log',
                        data: {
                            msg: '你传过来的数据有问题！',
                            yourData: newData
                        }
                    });
                    return;
                }

                console.log('收到数据刷新请求-newData=', newData);
                let {detail, dynamicData} = newData;
                this.$set(this, 'formData', dynamicData);
                this.$refs['baseInfo'].refreshData(detail);
            },
            /**
             * 单独刷新动态表单
             */
            refreshDynamic(newDynamicData) {
                this.$set(this, 'formData', newDynamicData);
            },
            saveFormData(value) {
                return this.submitForm(value);
            },
            submitForm(value) {
                // 准备提交数据-先进行基础数据校验
                // if (!this.$refs['baseInfo'].verifyBaseData()) {
                //     return null;
                // }
                if (!this.$refs['dynamicData'].verifyDynamicData(value)) {
                    return null;
                }
                // if (!this.$refs['baseInfo'].verifyGetData()) {
                //     return null;
                // }

                // let detail = this.$refs['baseInfo'].packDetailData();
                let dynamicData = this.$refs['dynamicData'].packDynamicData();
                let backData = {dynamicData}
                console.log('返回jq数据=', backData);
                return backData;
            },

        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dynamicArea {
        /*width: 828px;*/
    }
</style>
